// @ts-nocheck

import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';

import useMergeProps from '../../../hooks/useMergeProps';
import useModalContext from '../../../hooks/useModalContext';
import RoutesRedirectionFactory from '../../../utils/routes/RoutesRedirectionFactory';
import { openKLView } from '../actions/routes';
import KLBadgeDetails from '../components/KLBadgeDetails';
import { selectIsKLEnabled } from '../selectors/runtime';
import selectKLBadgeDetailsProps from '../selectors/specifics/selectKLBadgeDetailsProps';
import { KLCollectiblesSortedByRound, ReverseObfKLCollectibleIds } from '../types/collectible';
import { ObfKLRounds } from '../types/round';

type KLBadgeDetailsContainerProps = {
  className?: string;
};

const KLBadgeDetailsContainer = (ownProps: KLBadgeDetailsContainerProps) => {
  const { setOnBackButtonClick } = useModalContext();

  const dispatch = useDispatch();
  const onBackButtonClick = useCallback(
    () => () => {
      dispatch(openKLView());
    },
    [dispatch],
  );

  useEffect(() => {
    if (setOnBackButtonClick) {
      setOnBackButtonClick(onBackButtonClick);

      return () => {
        setOnBackButtonClick(null);
      };
    }
  }, [setOnBackButtonClick, onBackButtonClick]);

  const { obfBadgeId } = useParams();

  const badgeId = ReverseObfKLCollectibleIds[obfBadgeId];
  const foundRoundId = KLCollectiblesSortedByRound.findIndex(
    (collectibleIds) => collectibleIds.indexOf(badgeId) !== -1,
  );
  const obfRoundId = foundRoundId !== -1 ? foundRoundId + 1 : Infinity;
  const selectedProps = useSelector((state) => selectKLBadgeDetailsProps(state, { badgeId }));

  const otherProps = { badgeId };

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  const userRound = useSelector((state) => state.kl.user?.round);
  const isKLEnabled = useSelector(selectIsKLEnabled);

  if (isKLEnabled) {
    if (ObfKLRounds[userRound] < obfRoundId) {
      return <Redirect to={RoutesRedirectionFactory.getKLRoutePathname()} />;
    }

    return <KLBadgeDetails {...enhancedProps} />;
  }

  return <Redirect to={RoutesRedirectionFactory.getHomeRoutePathname()} />;
};

export default KLBadgeDetailsContainer;
